import axios from 'axios';

/*
*  This file contains all axios calls related to opportunity stage moved goal operations
*/

export const loadStages = async () => {
    const { data: opportunityStageList } = await axios.get('/app/opportunityFunnel/v2/stages');

    return opportunityStageList;
};
